var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row h-100 w-100"},[_c('p',{staticClass:"dv-title title-a"},[_vm._t("default")],2),_c('p',{staticClass:"numbers p-2 bd-highlight"},[_vm._v("\n        "+_vm._s(_vm.value)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }